import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { Breadcrumbs, Link, Typography } from '@mui/material'
import { Link as RouterLink, matchPath, useLocation } from 'react-router'

const breadcrumbNameMap: { [key: string]: string } = {
  '/org': 'Organization',
  '/projects': 'Projects',
  '/projects/new': 'Add Project',
  '/projects/:projectId': 'Details',
  '/projects/:projectId/edit': 'Edit Project',
  '/rfqs': 'RFQs',
  '/rfqs/new': 'Add RFQ',
  '/clients': 'Clients',
  '/clients/:clientId': 'Details',
  '/contacts': 'Contacts',
  '/vendors': 'Vendors',
  '/vendors/:vendorId': 'Details',
  '/import': 'Import',
  '/payment-entry': 'Payment Entry',
}

export default function PageHeaderBreadcrumbs() {
  const location = useLocation()
  const pathnames = location.pathname.split('/').filter((x) => x)

  return (
    <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="small" color="disabled" />}>
      <Link underline="hover" color="inherit" component={RouterLink} to="/">
        Home
      </Link>
      {pathnames.map((value, index) => {
        const last = index === pathnames.length - 1
        const to = `/${pathnames.slice(0, index + 1).join('/')}`
        const match = Object.entries(breadcrumbNameMap).find(([path, title]) => matchPath(path, to))
        const title = match ? match[1] : '???'

        return last ? (
          <Typography key={to} sx={{ color: 'text.primary' }}>
            {title}
          </Typography>
        ) : (
          <Link underline="hover" color="inherit" component={RouterLink} to={to} key={to}>
            {title}
          </Link>
        )
      })}
    </Breadcrumbs>
  )
}
